import '@/services';
import { SiteFonts } from '@/types/metadata';
const existsInSiteFonts = (fontName) => {
    if (SiteFonts.includes(fontName))
        return true;
    return false;
};
export const prepareDownload = async (theCode, outerDivID, callback = null) => {
    console.log('Preparing Download...');
    // Remove all the template code that we stored to send to convert
    document.getElementById('tempStoreImage').innerHTML = '';
    let tempStoreImageEl = document.getElementById('tempStoreImage');
    tempStoreImageEl.innerHTML += `<link href="https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;700&display=swap" rel="stylesheet">`;
    tempStoreImageEl.innerHTML += `<link href="https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap" rel="stylesheet">`;
    outerDivID = `#${outerDivID}`;
    // Clear out the arrays
    let tempCodeListOfBookIDs = [];
    let tempCodeListOfStampIDs = [];
    let tempCodeListOfTextIDs = [];
    let tempCodeListOfBookDIVs = $(outerDivID + " [id^='bookImgDiv']")
        .map(function () {
        return this.id;
    })
        .get();
    //Store all StampsIDs
    tempCodeListOfStampIDs = $(outerDivID + " [id^='stampID']")
        .map(function () {
        return this.id;
    })
        .get();
    // Replace jQuery map method with vanilla JavaScript
    const bookDivs = document.querySelectorAll(`${outerDivID} [id^='bookImgDiv']`);
    tempCodeListOfBookIDs = Array.from(bookDivs).map(div => div.id);
    // Store all StampsIDs
    const stampDivs = document.querySelectorAll(`${outerDivID} [id^='stampID']`);
    tempCodeListOfStampIDs = Array.from(stampDivs).map(div => div.id);
    let finalAdWidth = 0, finalAdHeight = 0;
    const templateLoaded = document.querySelector(`${outerDivID} #templateLoaded`);
    if (templateLoaded) {
        finalAdWidth = parseFloat(templateLoaded.getAttribute('fx') || '0');
        finalAdHeight = parseFloat(templateLoaded.getAttribute('fy') || '0');
    }
    //console.log(templateLoaded, finalAdHeight, finalAdWidth, outerDivID)
    // Store all TextIDs and add in the font styling depending on the font used in this image
    const tempStoreFontsCheck = [];
    const textDivs = document.querySelectorAll(`${outerDivID} [id^='userTextID']`);
    tempCodeListOfTextIDs = Array.from(textDivs).map(div => {
        const dynamicElement = div.querySelector('.dynamic');
        let fontFamilyToCheck = window.getComputedStyle(dynamicElement).fontFamily;
        const cleanedFontName = fontFamilyToCheck.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
        if (cleanedFontName) {
            fontFamilyToCheck = cleanedFontName;
        }
        const fontFamilyToCheckCleaned = fontFamilyToCheck.split(',')[0].replace(/['"]/g, '').trim();
        if (!tempStoreFontsCheck.includes(fontFamilyToCheckCleaned)) {
            const fontFamilyToCheckCleanedNoSpaces = fontFamilyToCheckCleaned.replace(/ /g, '').replace(/[^A-Za-z0-9 ]/g, '');
            const customFontStyleElement = document.querySelector(`#customFontsLoaded #customFontStyle${fontFamilyToCheckCleanedNoSpaces}`);
            const tempStoreImageElement = document.getElementById('tempStoreImage');
            if (customFontStyleElement) {
                tempStoreImageElement.innerHTML += customFontStyleElement.innerHTML;
            }
            else {
                const fontDiv = document.querySelector(`div.serverLoadedFont[data-fontfamily='${fontFamilyToCheckCleaned}']`);
                if (fontDiv) {
                    tempStoreImageElement.innerHTML += fontDiv.innerHTML;
                }
                else {
                    tempStoreImageElement.innerHTML += `<link href="https://fonts.googleapis.com/css?family=${fontFamilyToCheckCleaned}" rel="stylesheet">`;
                }
            }
        }
        return div.id;
    });
    try {
        let textElements = document.querySelectorAll('.userTextClass .dynamic');
        const tempStoreImageElement = document.getElementById('tempStoreImage');
        let fontsParsed = [];
        console.log(textElements);
        textElements.forEach(element => {
            const customFontLocation = element.getAttribute('data-nameoffontfile');
            const customFontName = element.getAttribute('data-customfontname');
            const userFontname = element.getAttribute('data-user-fontname');
            const userFontLocation = element.getAttribute('data-user-fonturl');
            const siteFontExist = existsInSiteFonts(customFontName);
            if (userFontLocation && userFontLocation !== '' && userFontname && userFontname !== '' && !siteFontExist) {
                if (fontsParsed.includes(userFontname))
                    return;
                fontsParsed.push(userFontname);
                const fontFace = document.createElement('style');
                fontFace.innerHTML = `@font-face {
            font-family: '${userFontname}';
            src: url('${userFontLocation}');
          }`;
                tempStoreImageElement.innerHTML += fontFace.outerHTML;
            }
            else if (customFontLocation && customFontLocation !== '' && !siteFontExist) {
                if (fontsParsed.includes(customFontName))
                    return;
                fontsParsed.push(customFontName);
                const fontFace = document.createElement('style');
                let site = window.location.protocol + '//' + window.location.hostname;
                if (window.location.port)
                    site += ':' + window.location.port;
                fontFace.innerHTML = `@font-face {
            font-family: '${customFontName}';
            src: url('${site}/wp-content/uploads/commun_templates/fonts/${customFontLocation}');
          }`;
                tempStoreImageElement.innerHTML += fontFace.outerHTML;
            }
        });
        // console.log('fontface',tempStoreImageElement.innerHTML)
        // console.log('Queued Fonts:', fontsParsed);
        // console.log('Loaded all custom fonts');
    }
    catch (error) {
        console.error('Error loading fonts', error);
    }
    //console.log(tempCodeListOfBookIDs,  tempCodeListOfStampIDs, tempCodeListOfTextIDs)
    document.getElementById('tempStoreImage').innerHTML += theCode;
    const theTempCode = document.getElementById('tempStoreImage');
    let widthForImageOrTemplate, heightForImageOrTemplate;
    widthForImageOrTemplate = finalAdWidth;
    heightForImageOrTemplate = finalAdHeight;
    // console.log(widthForImageOrTemplate, heightForImageOrTemplate)
    const finalImageToExport = theTempCode.querySelector('#finalImageToExport');
    finalImageToExport.style.width = `${widthForImageOrTemplate}px`;
    finalImageToExport.style.height = `${heightForImageOrTemplate}px`;
    let theCoversionRate = parseFloat(document.querySelector(`${outerDivID} #finalImageToExport`).style.width.replace('px', '')) / widthForImageOrTemplate;
    // Border
    const imageBorder = theTempCode.querySelector('#imageBorder');
    if (imageBorder) {
        const border = imageBorder.style.border; // "27px solid rgb(191, 241, 248)"
        let borderThickness = parseFloat(border.split(' ')[0].replace('px', '')); // 27
        const newBorderThickness = borderThickness / theCoversionRate;
        const newBorder = `${newBorderThickness}px ${border.split(' ')[1]} ${border.split(' ')[2]} ${border.split(' ')[3]} ${border.split(' ')[4]}`;
        imageBorder.style.border = newBorder;
    }
    finalImageToExport.style.width = `${widthForImageOrTemplate}px`;
    finalImageToExport.style.height = `${heightForImageOrTemplate}px`;
    const bkgImageContainer = finalImageToExport.querySelector('#bkgImageContainer');
    theTempCode.querySelectorAll('.backgroundImageWrapper').forEach(item => {
        const bkgimageID = item.id;
        const backgroundSelector = theTempCode.querySelector(`#${bkgimageID}`);
        if (backgroundSelector.style.top) {
            let newTop;
            if (backgroundSelector.hasAttribute('data-origtop')) {
                newTop = parseFloat(backgroundSelector.getAttribute('data-origtop').replace('px', '')) / theCoversionRate;
            }
            else {
                newTop = parseFloat(backgroundSelector.style.top.replace('px', '')) / theCoversionRate;
            }
            backgroundSelector.style.top = `${newTop}px`;
            backgroundSelector.setAttribute('data-origtop', `${newTop}`);
        }
        if (backgroundSelector.style.width) {
            backgroundSelector.style.width = `${parseFloat(backgroundSelector.style.width.replace('px', '')) / theCoversionRate}px`;
        }
        if (backgroundSelector.style.height) {
            backgroundSelector.style.height = `${parseFloat(backgroundSelector.style.height.replace('px', '')) / theCoversionRate}px`;
        }
        if (backgroundSelector.style.left) {
            let newLeft;
            if (backgroundSelector.hasAttribute('data-origleft')) {
                newLeft = parseFloat(backgroundSelector.getAttribute('data-origleft').replace('px', '')) / theCoversionRate;
            }
            else {
                newLeft = parseFloat(backgroundSelector.style.left.replace('px', '')) / theCoversionRate;
            }
            backgroundSelector.style.left = `${newLeft}px`;
            backgroundSelector.setAttribute('data-origleft', `${newLeft}`);
        }
        if (backgroundSelector.style.maxHeight) {
            backgroundSelector.style.maxHeight = `${parseFloat(backgroundSelector.style.maxHeight.replace('px', '')) / theCoversionRate}px`;
        }
        if (backgroundSelector.style.maxWidth) {
            backgroundSelector.style.maxWidth = `${parseFloat(backgroundSelector.style.maxWidth.replace('px', '')) / theCoversionRate}px`;
        }
        const backgroundSelectorOld = theTempCode.querySelector(`#${bkgimageID} img`);
        if (backgroundSelectorOld.style.filter) {
            const filters = backgroundSelectorOld.style.filter.split(' ');
            for (let j = 0; j < filters.length; j++) {
                if (filters[j].indexOf('blur') > -1) {
                    const whatToReplace = filters[j];
                    let newBlur = parseFloat(whatToReplace.replace('blur(', '').replace('px)', '')) / theCoversionRate;
                    backgroundSelectorOld.style.filter = backgroundSelectorOld.style.filter.replace(whatToReplace, `blur(${newBlur}px)`);
                }
            }
        }
        const filterStyle = backgroundSelectorOld.getAttribute('style');
        if (filterStyle && filterStyle.indexOf('-webkit-mask-image:') >= 0) {
            const bkgImageContainer = finalImageToExport.querySelector('#bkgImageContainer');
            if (!bkgImageContainer.style.backgroundColor) {
                bkgImageContainer.style.backgroundColor = 'rgba(255,255,255,1)';
            }
        }
        if (backgroundSelector.style.filter) {
            const filters = backgroundSelector.style.filter.split(' ');
            for (let j = 0; j < filters.length; j++) {
                if (filters[j].indexOf('blur') > -1) {
                    const whatToReplace = filters[j];
                    let newBlur = parseFloat(whatToReplace.replace('blur(', '').replace('px)', '')) / theCoversionRate;
                    backgroundSelector.style.filter = backgroundSelector.style.filter.replace(whatToReplace, `blur(${newBlur}px)`);
                }
            }
        }
    });
    theTempCode.querySelectorAll('.videoWrapper').forEach(item => {
        const videoWrapperSelector = theTempCode.querySelector(`#${item.id}`);
        if (videoWrapperSelector.style.top) {
            let newTop;
            if (videoWrapperSelector.hasAttribute('data-origtop')) {
                newTop = parseFloat(videoWrapperSelector.getAttribute('data-origtop').replace('px', '')) / theCoversionRate;
            }
            else {
                newTop = parseFloat(videoWrapperSelector.style.top.replace('px', '')) / theCoversionRate;
            }
            videoWrapperSelector.style.top = `${newTop}px`;
            videoWrapperSelector.setAttribute('data-origtop', `${newTop}`);
        }
        if (videoWrapperSelector.style.width) {
            videoWrapperSelector.style.width = `${parseFloat(videoWrapperSelector.style.width.replace('px', '')) / theCoversionRate}px`;
        }
        if (videoWrapperSelector.style.height) {
            videoWrapperSelector.style.height = `${parseFloat(videoWrapperSelector.style.height.replace('px', '')) / theCoversionRate}px`;
        }
        if (videoWrapperSelector.style.left) {
            let newLeft;
            if (videoWrapperSelector.hasAttribute('data-origleft')) {
                newLeft = parseFloat(videoWrapperSelector.getAttribute('data-origleft').replace('px', '')) / theCoversionRate;
            }
            else {
                newLeft = parseFloat(videoWrapperSelector.style.left.replace('px', '')) / theCoversionRate;
            }
            videoWrapperSelector.style.left = `${newLeft}px`;
            videoWrapperSelector.setAttribute('data-origleft', `${newLeft}`);
        }
    });
    tempCodeListOfBookDIVs.forEach(item => {
        const itemSelector = `#${item}`;
        const bookDivSelector = theTempCode.querySelector(itemSelector);
        if (bookDivSelector) {
            if (bookDivSelector.style.top) {
                let newTop;
                if (bookDivSelector.hasAttribute('data-origtop')) {
                    newTop = parseFloat(bookDivSelector.getAttribute('data-origtop').replace('px', '')) / theCoversionRate;
                }
                else {
                    newTop = parseFloat(bookDivSelector.style.top.replace('px', '')) / theCoversionRate;
                }
                bookDivSelector.style.top = `${newTop}px`;
                bookDivSelector.setAttribute('data-origtop', `${newTop}`);
            }
            if (bookDivSelector.style.width) {
                bookDivSelector.style.width = `${parseFloat(bookDivSelector.style.width.replace('px', '')) / theCoversionRate}px`;
            }
            if (bookDivSelector.style.height) {
                if (bookDivSelector.style.height === 'auto') {
                    const realHeight = document.querySelector(`${itemSelector} img`).naturalHeight;
                    const realWidth = document.querySelector(`${itemSelector} img`).naturalWidth;
                    const ratio = realWidth / realHeight;
                    const newHeight = `${parseInt($(itemSelector).css('width').replace('px', '')) / ratio}px`;
                    bookDivSelector.style.height = newHeight;
                }
                bookDivSelector.style.height = `${parseFloat(bookDivSelector.style.height.replace('px', '')) / theCoversionRate}px`;
            }
            if (bookDivSelector.style.left) {
                let newLeft;
                if (bookDivSelector.hasAttribute('data-origleft')) {
                    newLeft = parseFloat(bookDivSelector.getAttribute('data-origleft').replace('px', '')) / theCoversionRate;
                }
                else {
                    newLeft = parseFloat(bookDivSelector.style.left.replace('px', '')) / theCoversionRate;
                }
                bookDivSelector.style.left = `${newLeft}px`;
                bookDivSelector.setAttribute('data-origleft', `${newLeft}`);
            }
        }
        const itemID = itemSelector.replace('Div', 'ID');
        const bookDivSelectorID = theTempCode.querySelector(itemID);
        if (bookDivSelectorID) {
            if (bookDivSelectorID.style.width) {
                bookDivSelectorID.style.width = `${parseFloat(bookDivSelectorID.style.width.replace('px', '')) / theCoversionRate}px`;
            }
            if (bookDivSelectorID.style.height) {
                bookDivSelectorID.style.height = `${parseFloat(bookDivSelectorID.style.height.replace('px', '')) / theCoversionRate}px`;
            }
            if (bookDivSelectorID.style.left) {
                let newLeft;
                if (bookDivSelectorID.hasAttribute('data-origleft')) {
                    newLeft = parseFloat(bookDivSelectorID.getAttribute('data-origleft').replace('px', '')) / theCoversionRate;
                }
                else {
                    newLeft = parseFloat(bookDivSelectorID.style.left.replace('px', '')) / theCoversionRate;
                }
                bookDivSelectorID.style.left = `${newLeft}px`;
                bookDivSelectorID.setAttribute('data-origleft', `${newLeft}`);
            }
        }
    });
    //Text
    tempCodeListOfTextIDs.forEach(function (item, index) {
        item = '#' + item;
        const textSelector = theTempCode.querySelector(item);
        if (textSelector) {
            // Only adjust this if the text has width. The reason for this is because the width, height, and left style is only present if the user adjust the text. If they did not adjust the text, then this does not show and throws an error
            // UserTextID (outerDiv of text)
            if (textSelector.style.top) {
                let newTop;
                if (textSelector.hasAttribute('data-origtop')) {
                    newTop = parseFloat(textSelector.getAttribute('data-origtop').replace('px', '')) / theCoversionRate;
                }
                else {
                    newTop = parseFloat(textSelector.style.top.replace('px', '')) / theCoversionRate;
                }
                textSelector.style.top = newTop + 'px';
                textSelector.setAttribute('data-origtop', newTop.toString());
            }
            if (textSelector.style.width) {
                textSelector.style.width =
                    (parseFloat(textSelector.style.width.replace('px', '')) / theCoversionRate).toString() + 'px';
            }
            if (textSelector.style.height) {
                textSelector.style.height =
                    (parseFloat(textSelector.style.height.replace('px', '')) / theCoversionRate).toString() + 'px';
            }
            if (textSelector.style.left) {
                let newLeft;
                if (textSelector.hasAttribute('data-origleft')) {
                    newLeft = parseFloat(textSelector.getAttribute('data-origleft').replace('px', '')) / theCoversionRate;
                }
                else {
                    newLeft = parseFloat(textSelector.style.left.replace('px', '')) / theCoversionRate;
                }
                textSelector.style.left = newLeft + 'px';
                textSelector.setAttribute('data-origleft', newLeft.toString());
            }
            if (textSelector.style.border) {
                const textBorder = textSelector.style.border;
                const textBorderSizeWithPx = textBorder.split(' ');
                const newBorderSizeNoPx = parseFloat(textBorderSizeWithPx[0].replace('px', '')) / theCoversionRate;
                const newBorderValue = textBorder.replace(textBorderSizeWithPx[0], newBorderSizeNoPx + 'px');
                textSelector.style.border = newBorderValue;
            }
            if (textSelector.style.borderRadius) {
                const borderRadius = parseFloat(textSelector.style.borderRadius.replace('px', ''));
                const newBorderRadius = (borderRadius / theCoversionRate).toString() + 'px';
                textSelector.style.borderRadius = newBorderRadius;
            }
            const textInnerSelector = theTempCode.querySelector(item + '> div');
            // UserText
            if (textInnerSelector) {
                let textStyle = window.getComputedStyle(textInnerSelector);
                if (textStyle.fontSize) {
                    textInnerSelector.style.fontSize =
                        (parseFloat(textStyle.fontSize.replace('px', '')) / theCoversionRate).toString() + 'px';
                }
                if (textStyle.lineHeight) {
                    textInnerSelector.style.lineHeight =
                        (parseFloat(textStyle.lineHeight.replace('px', '')) / theCoversionRate).toString() + 'px';
                }
                if (textStyle.padding) {
                    textInnerSelector.style.padding =
                        (parseFloat(textStyle.padding.replace('px', '')) / theCoversionRate).toString() + 'px';
                }
                if (textStyle.letterSpacing) {
                    const letterSpacing = parseFloat(textStyle.letterSpacing.replace('px', ''));
                    const newLetterSpacing = (letterSpacing / theCoversionRate).toString() + 'px';
                    textInnerSelector.style.letterSpacing = newLetterSpacing;
                }
                // drop-shadow filter
                if (textStyle.filter) {
                    if (textStyle.filter.indexOf('drop-shadow(') > -1) {
                        // drop-shadow(rgb(82, 39, 255) 0px 0px 14px)
                        const thisFilter = textStyle.filter;
                        const saveSomeFilterValuesThatDoNotChange = thisFilter.split(' ').slice(0, 5).join(' ');
                        const thisFilterShadowSize = thisFilter.split(' ')[5];
                        const thisShadowSize = parseFloat(thisFilterShadowSize.split('px')[0]);
                        const newShadowSize = (thisShadowSize / theCoversionRate).toString() + 'px';
                        textInnerSelector.style.filter = saveSomeFilterValuesThatDoNotChange + ' ' + newShadowSize + ')';
                    }
                }
                // If there is background then that means it's for gradient text. The gradient text gets changed in the process of copying the code so we need to change it back.
                if (textInnerSelector?.style?.background && textInnerSelector?.style?.background.includes('text')) {
                    // textInnerSelector.style.background = textInnerSelector.style.background.replace("text", "");
                    if (!textInnerSelector?.style?.webkitTextFillColor)
                        textInnerSelector.style.webkitTextFillColor = 'transparent';
                    // const currentStyle = $("#tempStoreImage " + item).attr('style');
                    // $("#tempStoreImage " + item).attr('style', currentStyle + " -webkit-background-clip: text;");
                }
                else if (textInnerSelector?.style?.backgroundImage &&
                    textInnerSelector?.style?.backgroundImage.includes('text')) {
                    if (!textStyle.webkitTextFillColor)
                        textInnerSelector.style.webkitTextFillColor = 'transparent';
                    // const currentStyle = $("#tempStoreImage " + item).attr('style');
                    // $("#tempStoreImage " + item).attr('style', currentStyle + " -webkit-background-clip: text;");
                }
                else if (textInnerSelector.getAttribute('data-original-color-a')) {
                    const textEl = textInnerSelector;
                    const colorA = textEl.getAttribute('data-original-color-a');
                    const colorB = textEl.getAttribute('data-original-color-b');
                    $(textEl).addClass('backgroundClipText');
                    textEl.style.background = 'linear-gradient(45deg, ' + colorA + ', ' + colorB + ' 80%)';
                    if (!textStyle.webkitTextFillColor)
                        textEl.style.webkitTextFillColor = 'transparent';
                }
                if (textInnerSelector?.style?.webkitTextStroke) {
                    console.log('webkitTextStroke', textInnerSelector.style.webkitTextStroke, textStyle.webkitTextStroke);
                    const textStroke = textInnerSelector.style.webkitTextStroke;
                    const textStrokeSizeWithPx = textStroke.split(' ');
                    const newStrokeSizeNoPx = parseFloat(textStrokeSizeWithPx[0].replace('px', '')) / theCoversionRate;
                    const newStrokeValue = textStroke.replace(textStrokeSizeWithPx[0], newStrokeSizeNoPx + 'px');
                    textInnerSelector.style.webkitTextStroke = newStrokeValue;
                }
            }
        }
    });
    //Stamps
    tempCodeListOfStampIDs.forEach(function (item, index) {
        item = '#' + item;
        const stampSelector = theTempCode.querySelector(item);
        if (stampSelector) {
            stampSelector.querySelectorAll('.editButton').forEach(item => item.remove());
            if (stampSelector.style.top) {
                let newTop;
                if (stampSelector.hasAttribute('data-origtop')) {
                    newTop = parseFloat(stampSelector.getAttribute('data-origtop').replace('px', '')) / theCoversionRate;
                }
                else {
                    newTop = parseFloat(stampSelector.style.top.replace('px', '')) / theCoversionRate;
                }
                stampSelector.style.top = newTop + 'px';
                stampSelector.setAttribute('data-origtop', newTop.toString());
            }
            if (stampSelector.style.width) {
                stampSelector.style.width =
                    (parseFloat(stampSelector.style.width.replace('px', '')) / theCoversionRate).toString() + 'px';
            }
            if (stampSelector.style.height) {
                stampSelector.style.height =
                    (parseFloat(stampSelector.style.height.replace('px', '')) / theCoversionRate).toString() + 'px';
            }
            if (stampSelector.style.left) {
                let newLeft;
                if (stampSelector.hasAttribute('data-origleft')) {
                    newLeft = parseFloat(stampSelector.getAttribute('data-origleft').replace('px', '')) / theCoversionRate;
                }
                else {
                    newLeft = parseFloat(stampSelector.style.left.replace('px', '')) / theCoversionRate;
                }
                stampSelector.style.left = newLeft + 'px';
                stampSelector.setAttribute('data-origleft', newLeft.toString());
            }
            if (stampSelector.style.maxHeight) {
                stampSelector.style.maxHeight =
                    (parseFloat(stampSelector.style.maxHeight.replace('px', '')) / theCoversionRate).toString() + 'px';
            }
            if (stampSelector.style.maxWidth) {
                stampSelector.style.maxWidth =
                    (parseFloat(stampSelector.style.maxWidth.replace('px', '')) / theCoversionRate).toString() + 'px';
            }
            const stampInnerSelector = stampSelector.querySelector('.stampImg');
            if (stampInnerSelector) {
                if (stampInnerSelector.style.padding) {
                    stampInnerSelector.style.padding =
                        (parseFloat(stampInnerSelector.style.padding.replace('px', '')) / theCoversionRate).toString() + 'px';
                }
                if (stampInnerSelector.style.borderRadius) {
                    const borderRadius = parseFloat(stampInnerSelector.style.borderRadius.replace('px', ''));
                    const newBorderRadius = (borderRadius / theCoversionRate).toString() + 'px';
                    stampInnerSelector.style.borderRadius = newBorderRadius;
                }
                if (stampInnerSelector.style.filter) {
                    const filters = stampInnerSelector.style.filter.split(' ');
                    // Loop through array of filters to see if blur is one of them
                    for (let i = 0; i < filters.length; i++) {
                        if (filters[i].indexOf('blur') > -1) {
                            const whatToReplace = filters[i];
                            // Now just get the number
                            let newBlur = parseFloat(whatToReplace.replace('blur(', '').replace('px)', ''));
                            newBlur = newBlur / theCoversionRate;
                            stampInnerSelector.style.filter = stampInnerSelector.style.filter.replace(whatToReplace, `blur(${newBlur}px)`);
                        }
                    }
                }
            }
        }
    });
    theTempCode.querySelectorAll('.shapeOuter').forEach(function (item, index) {
        let itemid = '#' + item.id;
        const shapeSelector = theTempCode.querySelector(itemid);
        if (shapeSelector) {
            if (shapeSelector.style.top) {
                let newTop;
                if (shapeSelector.hasAttribute('data-origtop')) {
                    newTop = parseFloat(shapeSelector.getAttribute('data-origtop').replace('px', '')) / theCoversionRate;
                }
                else {
                    newTop = parseFloat(shapeSelector.style.top.replace('px', '')) / theCoversionRate;
                }
                shapeSelector.style.top = newTop + 'px';
                shapeSelector.setAttribute('data-origtop', newTop.toString());
            }
            if (shapeSelector.style.width) {
                shapeSelector.style.width =
                    (parseFloat(shapeSelector.style.width.replace('px', '')) / theCoversionRate).toString() + 'px';
            }
            if (shapeSelector.style.height) {
                shapeSelector.style.height =
                    (parseFloat(shapeSelector.style.height.replace('px', '')) / theCoversionRate).toString() + 'px';
            }
            if (shapeSelector.style.left) {
                let newLeft;
                if (shapeSelector.hasAttribute('data-origleft')) {
                    newLeft = parseFloat(shapeSelector.getAttribute('data-origleft').replace('px', '')) / theCoversionRate;
                }
                else {
                    newLeft = parseFloat(shapeSelector.style.left.replace('px', '')) / theCoversionRate;
                }
                shapeSelector.style.left = newLeft + 'px';
                shapeSelector.setAttribute('data-origleft', newLeft.toString());
            }
            const shapeSVGSelector = theTempCode.querySelector(itemid + ' svg');
            if (shapeSVGSelector && shapeSVGSelector.style.filter) {
                const filters = shapeSVGSelector.style.filter.split(' ');
                // Loop through array of filters to see if blur is one of them
                for (let i = 0; i < filters.length; i++) {
                    if (filters[i].indexOf('blur') > -1) {
                        const whatToReplace = filters[i];
                        // Now just get the number
                        let newBlur = parseFloat(whatToReplace.replace('blur(', '').replace('px)', ''));
                        newBlur = newBlur / theCoversionRate;
                        shapeSVGSelector.style.filter = shapeSVGSelector.style.filter.replace(whatToReplace, `blur(${newBlur}px)`);
                    }
                }
            }
        }
    });
    const bkgImageContainter = finalImageToExport.querySelector('#bkgImageContainter');
    const imgElements = document.querySelectorAll('#tempStoreImage img');
    imgElements.forEach(img => {
        const src = img.getAttribute('src');
        if (src && src.charAt(0) === '/') {
            const newSrc = `https://${window.location.hostname}${src}`;
            img.setAttribute('src', newSrc);
        }
    });
    theCode = document.getElementById('tempStoreImage').innerHTML;
    let whatToConvert = `<div style='display: none;'>${document.getElementById('customCreatorCss').innerHTML}</div>`;
    theCoversionRate =
        parseFloat(document.querySelector(`${outerDivID} #finalImageToExport`).style.width.replace('px', '')) / widthForImageOrTemplate;
    whatToConvert += `<div style='display: none;'><style>body{background-color: transparent; margin: 0; padding: 0;} * {-webkit-box-sizing: border-box;-moz-box-sizing: border-box;}#finalImageToExport{outline: none;} .boundaries, .downloadedBoundary{display: none;}</style></div>`;
    var javascriptCodeToAdd = `
  <script>
      Promise.all(Array.from(document.images).filter(img => !img.complete).map(img => new Promise(resolve => { img.onload = img.onerror = resolve; }))).then(() => {
        setTimeout(() => { 
            document.getElementById(\"captureThis\").innerHTML += \"<img id='allImagesLoaded' src='https://bookbrush.com/custom-code/images/imagesLoaded.png' height='1' width='1' />\";
        }, 2000);
      }); 
      
  </script>
  `;
    var cssCodeToAdd = `
  <style>
      .videoWrapper { display: none; }
      .downloadedBoundary { display: block !important; border: none !important; }
  </style>
`;
    whatToConvert +=
        "<div id='captureThis' style='width: " +
            widthForImageOrTemplate +
            'px; height: ' +
            heightForImageOrTemplate +
            "px; float: left;'>" +
            theCode +
            '</div>';
    whatToConvert =
        '<html>' +
            cssCodeToAdd +
            "<body style='width: " +
            widthForImageOrTemplate +
            'px; height: ' +
            heightForImageOrTemplate +
            "px;'>" +
            whatToConvert +
            '</body>' +
            javascriptCodeToAdd +
            '</html>';
    document.getElementById('tempStoreImage').innerHTML = '';
    return whatToConvert;
};
